import { ReactNode } from 'react'
import styles from './StarReviewRating.module.scss'

export interface StarReviewRatingProps {
  score: string
  distributorName: string
  globalRatings: string
  stars: number
}

export function StarReviewRating({
  score,
  distributorName,
  globalRatings,
  stars = 1,
}: StarReviewRatingProps): ReactNode {
  const starValues = Array.from({ length: stars }, (_, i) => i + 1)

  return (
    <div className={styles.StarReviewRating}>
      <div className={styles.StarReviewRating__container}>
        <div className={styles.StarReviewRating__ratingContainer}>
          <p className={styles.StarReviewRating__rating}>{score}</p>
          <div
            aria-label={`${stars} star${stars > 1 ? 's' : ''}`}
            className={styles.StarReviewRating__stars}
          >
            {starValues.map(star => (
              <img key={`star-${star}`} alt="small star icon" src="/icons/small-star.svg" />
            ))}
          </div>
        </div>
        <p className={styles.StarReviewRating__appDistributor}>{distributorName}</p>
      </div>
      <p className={styles.StarReviewRating__globalRatings}>{globalRatings}</p>
    </div>
  )
}
